import { Stepper } from "src/components/ui-x";

/**
 * Wraps the reference stepper. The hand-rolled version positioned its labels
 * with `absolute top-0 mt-16`, which is why every caller had to add a `!mt-20`
 * spacer underneath it — ui-x lays the label out in flow instead.
 *
 * Props are unchanged: `steps` is a string[], `currentStep` is 1-based.
 */
function StepperIndicator({ steps = [], currentStep = 1 }) {
  return (
    <Stepper
      steps={steps.map((label) => ({ label }))}
      current={currentStep - 1}
    />
  );
}

export default StepperIndicator;
